






































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import learningRequestsList, {
  LearningRequestsListParams
} from "@/getinfo-api/learning-requests";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import { getCurrentCompanyId } from "@/plugins/roles";
import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import ShowMoreButton from "@/components/form/ShowMoreButton.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { debounce } from "lodash";
import { LearningRequestShortList as ILearningRequestShortList } from "@/api/models/learning-request-short-list";
import { LearningResourceInfo as ILearningResourceInfo } from "@/api/models/learning-resource-info";
import courses, { CourseListParams } from "@/getinfo-api/course";
import { CourseUnion as ICourse } from "@/api/models/course-union";

@Component({ components: { ShowMoreButton, OrderItemPreview, CustomButton } })
export default class LearningRequest extends Vue {
  @Prop() contractorId: any;
  searchString!: string;
  learningResource!: ILearningResourceInfo;
  checkedRequests: Array<ILearningRequest> = [];
  params: LearningRequestsListParams = {
    contractorId: this.contractorId,
    companyId: this.currentCompany,
    number: this.searchString,
    offset: 0,
    limit: 30,
    status: "not_processed"
  };
  isDisableAddButton: boolean = false;

  data() {
    return {
      searchString: undefined,
      learningResource: undefined
    };
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get debouncedRequest() {
    return debounce(this.getLearningDebounceRequests, 500);
  }

  get learningRequestsList() {
    return learningRequestsList;
  }

  getLearningDebounceRequests() {
    this.$store.commit("showMore/CLEAR_SHOW_MORE");
    this.$store.commit("showMore/CHANGE_IS_ACTION");
    this.checkedRequests = [];
    let params: LearningRequestsListParams = {
      contractorId: this.contractorId,
      companyId: this.currentCompany,
      number: this.searchString,
      offset: this.params.offset,
      limit: this.params.limit,
      status: "not_processed"
    };
    learningRequestsList(params)
      .then((res: { data: ILearningRequestShortList }) => {
        this.$store.commit("showMore/SET_COUNT", res.data.count);
        this.$store.commit("showMore/ADD_ITEMS", res.data.requests);
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.$store.commit("showMore/CHANGE_IS_ACTION");
      });
  }

  get currentCompany() {
    return getCurrentCompanyId();
  }

  get learningRequests(): Array<ILearningRequest> {
    return this.$store.getters["showMore/ITEMS"];
  }

  selectRequest(request: ILearningRequest) {
    this.checkedRequests.includes(request)
      ? (this.checkedRequests = this.checkedRequests.filter(
          el => el !== request
        ))
      : this.checkedRequests.push(request);
  }

  async addCheckedResource() {
    this.isDisableAddButton = true;

    const allSelectedCourse = this.checkedRequests
      ?.filter(
        el => el.resourceType === "course" || el.resourceType === "course2"
      )
      .map(el => el.resourceId);
    const uniqIds = new Set(allSelectedCourse);
    const uniqIdsArray = [...uniqIds];

    const params: CourseListParams = {
      ids: uniqIdsArray,
      limit: 30
    };

    try {
      let detailCourses: ICourse[] = [];
      if (params.ids?.length) {
        let response = await courses(params);
        detailCourses = response.data.courses;
      }
      const getHoursByCourseId = (courseId: string): number => {
        const [course] = detailCourses?.filter(el => el.id === courseId);
        return course.hours ? course.hours : 0;
      };

      this.checkedRequests.forEach(el => {
        if (el.resourceTitle) {
          this.learningResource = {
            id: el.resourceId,
            type: el.resourceType,
            title: el.resourceTitle,
            learningRequestId: el.id,
            userIds: el.users.map(el => el.id),
            price: +(el.price / el.users.length).toFixed(0),
            creationMethod: 1,
            amount: el.price,
            hours:
              el.resourceType === "course"
                ? getHoursByCourseId(el.resourceId)
                : 0
          };
        }
        this.$emit("getContractLearningResource", this.learningResource);
        this.learningResource = {} as ILearningResourceInfo;
      });
      this.isDisableAddButton = false;
      this.$emit("cancel");
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isDisableAddButton = false;
    }
  }

  @Watch("contractorId")
  UpdateLearningResources() {
    this.getLearningDebounceRequests();
  }

  beforeDestroy() {
    this.$store.commit("showMore/CLEAR_SHOW_MORE");
  }
}
